var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgXSolid = function SvgXSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.026 1.75h2.146l-4.69 5.295L15 14.25h-4.32L7.297 9.88l-3.873 4.37H1.277l5.016-5.664L1 1.75h4.43l3.058 3.994zm-.753 11.231h1.189L4.784 2.953H3.507z"
  })));
};
export { SvgXSolid as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik0xMi4wMjYgMS43NWgyLjE0NmwtNC42OSA1LjI5NUwxNSAxNC4yNWgtNC4zMkw3LjI5NyA5Ljg4bC0zLjg3MyA0LjM3SDEuMjc3bDUuMDE2LTUuNjY0TDEgMS43NWg0LjQzbDMuMDU4IDMuOTk0em0tLjc1MyAxMS4yMzFoMS4xODlMNC43ODQgMi45NTNIMy41MDd6Ii8+PC9zdmc+Cg==";